module.exports = __webpack_public_path__ + "img/surgerybanner.2113fb71.jpg";